import React from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";

import Announcements from "./Announcements";
import Resources from "./Resources";
import SchoolFeedbackWidget from "./SchoolFeedbackWidget";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import CoursePlanningLogViewer from "../../CcpAdmin/CcpAdminCoursePlanning/inc/CoursePlanningLogViewer";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminDash = () => {
  const icon = faBarChart;

  return (
    <Grid container spacing={3} sx={{ padding: 3 }}>
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Resources />
      </Grid>
      <Grid item xs={12} md={12}>
        <Announcements />
      </Grid>
      <Grid item xs={12} md={12}>
        <CcpAdminBreadCrumbs pageName="Dashboard" icon={icon} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <SchoolFeedbackWidget />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Course Planning Activity Logs" />
          <CardContent sx={{ height: 400, overflow: "auto" }}>
            <CoursePlanningLogViewer
              compact={true}
              maxResults={50}
              schoolId={null}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CcpAdminDash;
